const prepareData = (
	validation: types.topUpAddOns.IValidation,
	formData: types.topUpAddOns.IFormData,
	numbers: string[],
	unitPrice: number,
	email: string,
	subscriptionId: string,
	totalAmount: number,
	itemType: string,
	numberOfOrders: number,
	DISABLE_SMART_PAY?: boolean,
	donation?: types.topUpAddOns.IDonation
) => {
	let items: any[] = numbers.map((number) => ({
		billingType: 'PREPAID',
		type: itemType,
		code: number,
		unitPrice,
	}));
	if (donation) {
		const item = {
			type: 'CHARITY',
			unitPrice: donation.value,
			quantity: 1,
			name: donation.charity.name,
			code: donation.charity.code,
		};
		items.push(item);
	}

	const payload: any = {
		type: 'LOYALTY_SUBSCRIPTION',
		subscriptionId,
		totalPrice: totalAmount,
		quantity: numberOfOrders,
		billingAddress: {
			firstName: formData.holder,
			lastName: formData.holder,
			country: 'OM',
			email: email,
		},
		items,
	};

	if (formData.type === 'card') {
		payload.card = {
			type: validation.number!.card!.type!.toUpperCase(),
			number: formData.number,
			cvv: formData.cvv,
			expiration: {
				month: validation.date.month,
				year: validation.date.year,
			},
		};
	} else {
		payload.paymentToken = formData.tokenId;
	}
	payload.DISABLE_SMART_PAY = DISABLE_SMART_PAY;
	payload.createPaymentToken = formData.saveCard;
	return payload;
};

export default prepareData;
